import { observer } from "mobx-react";
import { Button } from "primereact/button";
import React, { useContext } from "react";
import styled from "styled-components";
import { useLocStore } from "../../../../wsLocalization";
import { LocContext } from "../../../../wsLocalization/LocContext";
import { concatClassnames } from "../../../../WSUtils/util";
import { CVEditContext } from "../../CVEditContext";
import { CVEditDocument } from "../Components/CVEditDocument";
import { CVEditDocumentBaseList } from "../Components/CVEditDocumentsBaseList";
import { CVEditAttachmentsSegmentStore } from "./CVEditAttachmentsSegmentStore";

export interface CVEditAttachmentsListProps {
  attachmentsSegmentStore: CVEditAttachmentsSegmentStore;
}

export const CVEditAttachmentsList = observer(
  ({ attachmentsSegmentStore }: CVEditAttachmentsListProps) => {
    const cvEditContext = useContext(CVEditContext);

    return (
      <StyledCVEditDocumentBaseList
        className={concatClassnames([
          cvEditContext.layoutClassName,
          "cve-attachments-list",
        ])}
        items={attachmentsSegmentStore.attachedDocuments}
        OnRenderButtons={(props) => (
          <Buttons
            cveDocument={props.cveDocument}
            attachmentsSegmentStore={attachmentsSegmentStore}
          />
        )}
      />
    );
  }
);

const StyledCVEditDocumentBaseList = styled(CVEditDocumentBaseList)`
  &.cve-attachments-list {
    .cve-remove-attachment-button {
      padding: 0.15rem 0.35rem;
      font-size: 0.75em;
      font-weight: bold;
    }

    .cve-listing-buttons {
      margin-right: 0.5rem;
    }
  }
`;
interface ButtonsProps {
  cveDocument: CVEditDocument;
  attachmentsSegmentStore: CVEditAttachmentsSegmentStore;
}

const Buttons = observer(
  ({ cveDocument, attachmentsSegmentStore }: ButtonsProps) => {
    const L = useLocStore(LocContext.CV);
    const cvEditContext = useContext(CVEditContext);

    return (
      <Button
        className="p-button-outlined cve-remove-attachment-button"
        label={L.id("97106d6aa136").loc("Fjern")}
        onClick={(evt) => {
          evt.preventDefault();

          attachmentsSegmentStore.removePersistedAttachment(cveDocument.id);

          return false;
        }}
      />
    );
  }
);
